import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import About from './About';
import Services from './Services';
import Blog from './Blog';
import Contact from './Contact';
import Home from './Home';
import Industries from './Industries';
import Header from './Header';
import Footer from './Footer';
import PrivacyPolicy from './PrivacyPolicy';
import ScrollToTop from './ScrollToTop'; // ✅ ScrollToTop component
import BlogDetail from './BlogDetail';

// Services pages
import Taxation from './Taxation';
import VirtualCFO from './VirtualCFO';
import PayrollHR from './PayrollHR';
import StartupConsulting from './StartupConsulting';
import BusinessAdvisory from './BusinessAdvisory';
import Bookkeeping from './Bookkeeping';
import CorporateLaw from './CorporateLaw';
import InternationalBusiness from './InternationalBusiness';

// Industries pages
import ITSoftware from './ITSoftware';
import ManufacturingEngineering from './ManufacturingEngineering';
import RealEstate from './RealEstate';
import MediaEntertainment from './MediaEntertainment';
import RetailEcommerce from './RetailEcommerce';
import BFSI from './BFSI';
import TourismHospitality from './TourismHospitality';
import AgroAqua from './AgroAqua';
import HealthCare from './HealthCare';
import Education from './Education';
import NGOsTrusts from './NGOsTrusts';

function App() {
  return (
    <Router>
      <ScrollToTop /> {/* Ensures scroll to top on route change */}
      <Header />

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/919603059997?text=Hi%20Fintexl,%20I%20want%20to%20connect%20with%20you!"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="/images/whatsapp-final1.png" alt="WhatsApp" />
      </a>

      <Routes>
        {/* Static Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogDetail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />

        {/* Services Pages */}
        <Route path="/services/taxation" element={<Taxation />} />
        <Route path="/services/virtual-cfo" element={<VirtualCFO />} />
        <Route path="/services/payroll-hr" element={<PayrollHR />} />
        <Route path="/services/startup-consulting" element={<StartupConsulting />} />
        <Route path="/services/business-advisory" element={<BusinessAdvisory />} />
        <Route path="/services/bookkeeping" element={<Bookkeeping />} />
        <Route path="/services/corporate-law" element={<CorporateLaw />} />
        <Route path="/services/international-business" element={<InternationalBusiness />} />

        {/* Industries Pages */}
        <Route path="/industries/it-software" element={<ITSoftware />} />
        <Route path="/industries/manufacturing-engineering" element={<ManufacturingEngineering />} />
        <Route path="/industries/real-estate" element={<RealEstate />} />
        <Route path="/industries/media-entertainment" element={<MediaEntertainment />} />
        <Route path="/industries/retail-ecommerce" element={<RetailEcommerce />} />
        <Route path="/industries/bfsi" element={<BFSI />} />
        <Route path="/industries/tourism-hospitality" element={<TourismHospitality />} />
        <Route path="/industries/agro-aqua" element={<AgroAqua />} />
        <Route path="/industries/healthcare" element={<HealthCare />} />
        <Route path="/industries/education" element={<Education />} />
        <Route path="/industries/ngos-trusts" element={<NGOsTrusts />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;
